let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c5ZK9")).then(() => parcelRequire('4SXIq'));